import React from 'react';
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  IconButton,
  Menu,
  MenuItem,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate, Link } from 'react-router-dom';

const LandingNavbar = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  return (
    <AppBar
      position="fixed"
      elevation={2}
      sx={{
        px: 3,
        py: 1,
        backdropFilter: 'blur(6px)',
        backgroundColor: 'rgba(255,255,255,0.9)',
        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
      }}
    >
      <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
        {/* Logo */}
        <Button
          component={Link}
          to="/"
          sx={{ display: 'flex', alignItems: 'center', p: 0, minWidth: 'auto' }}
        >
          <img
            src="https://www.delightsupportedliving.co.uk/images/logo.png"
            alt="DSL Logo"
            style={{
              height: 90,
              maxWidth: '250px',
              objectFit: 'contain',
            }}
          />
        </Button>

        {/* Desktop Nav Links */}
        {!isMobile && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            <Button
              component={Link}
              to="/about"
              sx={{
                color: '#000',
                fontWeight: 600,
                textTransform: 'uppercase',
                '&:hover': { color: '#007bff' },
              }}
            >
              About Us
            </Button>
            <Button
              component={Link}
              to="/services"
              sx={{
                color: '#000',
                fontWeight: 600,
                textTransform: 'uppercase',
                '&:hover': { color: '#007bff' },
              }}
            >
              Services
            </Button>
            <Button
              component={Link}
              to="/contact"
              sx={{
                color: '#000',
                fontWeight: 600,
                textTransform: 'uppercase',
                '&:hover': { color: '#007bff' },
              }}
            >
              Contact
            </Button>

            {/* Login Button */}
            <Button
              variant="outlined"
              onClick={() => navigate('/login')}
              sx={{
                fontWeight: 600,
                borderColor: '#007bff',
                color: '#007bff',
                '&:hover': {
                  bgcolor: '#007bff',
                  color: '#fff',
                },
              }}
            >
              Login
            </Button>

            {/* Register Button (same style as Login) */}
            <Button
              variant="outlined"
              onClick={() => navigate('/register')}
              sx={{
                fontWeight: 600,
                borderColor: '#28a745', // green
                color: '#28a745',
                '&:hover': {
                  bgcolor: '#28a745',
                  color: '#fff',
                },
              }}
            >
              Register
            </Button>
          </Box>
        )}

        {/* Mobile Nav Menu */}
        {isMobile && (
          <>
            <IconButton onClick={handleMenuOpen} edge="end">
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem component={Link} to="/about" onClick={handleMenuClose}>
                About Us
              </MenuItem>
              <MenuItem component={Link} to="/services" onClick={handleMenuClose}>
                Services
              </MenuItem>
              <MenuItem component={Link} to="/contact" onClick={handleMenuClose}>
                Contact
              </MenuItem>
              <MenuItem
                onClick={() => {
                  navigate('/login');
                  handleMenuClose();
                }}
              >
                Login
              </MenuItem>
              <MenuItem
                onClick={() => {
                  navigate('/register');
                  handleMenuClose();
                }}
              >
                Register
              </MenuItem>
            </Menu>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default LandingNavbar;
